// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609151134/js/" + chunkId + "." + {"44":"57b5d91b","225":"58340541","481":"785b5481","486":"ceed87ff","770":"818f54dc"}[chunkId] + ".0.7594104187173615.chunk.js";
};